import { Page } from "@/models/page-models/Page";

export const InvoiceView: Page = {
  "path": "invoice/:invoiceId",
  "name": "Invoice",
  "props": {
    "data": {
      "title": "Tax Invoice",
      "printable": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.invoiceVersion}},'),==,'v1'),||,fn(NOT,fn(NOT,{{fetchedData.invoiceDetails.data.qr}})))",
      "url": "invoice/:invoiceId",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "custom_InvoiceDetails",
                  "variable": "formData.invoiceDetails.data",
                  "label": "Invoice Details",
                  "disabled": "FALSE",
                  "showIf": "{{formData.invoiceDetails.data}}",
                  "config": {
                    "customerDetailsVariable": "formData.customerDetails.data"
                  }
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Invoice Orders",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.formattedOrders}}",
                  "items": "fetchedData.formattedOrders",
                  "headers": [
                    {
                      "value": "slNo",
                      "text": "#",
                      "width": 40
                    },
                    {
                      "value": "order",
                      "text": "Order #\\n<span style=\"font-size: 0.5rem;\"># حزمة</span>",
                      "width": 70,
                      "type": "url",
                      "url": "/order/{{__item.order}}"
                    },
                    {
                      "value": "description",
                      "text": "Description\\n<span style=\"font-size: 0.5rem;\">التفاصيل</span>",
                      "width": 200
                    },
                    {
                      "value": "unit",
                      "text": "Unit\\n<span style=\"font-size: 0.5rem;\">الوحدة</span>",
                      "width": 61
                    },
                    {
                      "value": "quantity",
                      "text": "Quantity\\n<span style=\"font-size: 0.5rem;\">الكمية</span>",
                      "width": 76
                    },
                    {
                      "value": "currency",
                      "text": "Cur.\\n<span style=\"font-size: 0.5rem;\">العملة</span>",
                      "width": 50
                    },
                    {
                      "value": "unitPrice",
                      "text": "Price\\n<span style=\"font-size: 0.5rem;\">السعر</span>",
                      "width": 58
                    },
                    {
                      "value": "subTotal",
                      "text": "Subtotal\\n<span style=\"font-size: 0.5rem;\">المجموع الفرعي</span>",
                      "width": 110
                    },
                    {
                      "value": "vatRate",
                      "text": "VAT %\\n<span style=\"font-size: 0.5rem;\">الضريبة %</span>",
                      "width": 79
                    },
                    {
                      "value": "vatValue",
                      "text": "VAT\\n<span style=\"font-size: 0.5rem;\">الضريبة</span>",
                      "width": 91
                    },
                    {
                      "value": "total",
                      "text": "Total + VAT\\n<span style=\"font-size: 0.5rem;\">المجموع + الضريبة</span>",
                      "width": 120
                    }
                  ],
                  "tableType": "static",
                  "showActions": false,
                  "fontSize": "0.75rem;"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "custom_InvoiceTotal",
                  "variable": "formData.invoiceDetails.data.orders",
                  "label": "Sub Total",
                  "disabled": "FALSE",
                  "config": {
                    "subTotalFormula": "{{formData.invoiceDetails.data.subtotal}}",
                    "totalFormula": "{{formData.invoiceDetails.data.total}}",
                    "companyDetails": "{{fetchedData.companyDetails.data.0.data}}",
                    "docDetails": "{{formData.invoiceDetails.data}}",
                    "showQrCode": true,
                    "qrCodeVariable": "fetchedData.invoiceDetails.data.qr",
                    "vatVariable": "{{fetchedData.vatPercent}}"
                  }
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Clear Invoice",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "clearInvoice",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/e-invoicing/clear-invoice/{{__params.invoiceId}}?type=Invoice",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE",
                        "arg4Key": "requestMethod",
                        "arg4Value": "GET"
                      },
                      "name": "clearInvoice"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.invoiceVersion}},'),==,'v2'),&&,fn(NOT,{{fetchedData.invoiceDetails.data.qr}}))",
                  "color": "secondary"
                }
              ],
              "showIf": "fn(LOGICAL,fn(MATCH_ROLE,Customer Service | Manager),||,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive)))"
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Print Invoice",
                  "onClick": [
                    {
                      "executionOrder": 3,
                      "pageFunction": {
                        "name": "printInvoice",
                        "type": "fnPrint"
                      },
                      "name": "printInvoice"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.invoiceVersion}},'),==,'v1'),||,fn(NOT,fn(NOT,{{fetchedData.invoiceDetails.data.qr}})))",
                  "color": "primary"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true,
      "arabicTitle": "فاتورة ضريبية",
      "printDocDate": "{{fetchedData.invoiceDetails.data.createdAt}}"
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getInvoiceDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/invoice/{{__params.invoiceId}}",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.invoiceDetails"
        },
        "name": "getInvoiceDetails"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getCompanyDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=company-detail",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.companyDetails"
        },
        "name": "getCompanyDetails"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "copyExistingCarbonCopy",
          "type": "fnCopyData",
          "arg1Key": "sourceKey",
          "arg1Value": "fetchedData.invoiceDetails.data.cc.0.data",
          "arg2Key": "destinationKey",
          "arg2Value": "formData",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "copyExistingCarbonCopy",
        "executeIf": "fn(LOGICAL,fn(LENGTH,{{fetchedData.invoiceDetails.data.cc}}),>,0)"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "copyInvoiceVersion",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getInvoiceVersion",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "copyInvoiceVersion"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "copyInvoiceDetails",
          "type": "fnCopyData",
          "arg1Key": "sourceKey",
          "arg1Value": "fetchedData.invoiceDetails",
          "arg2Key": "destinationKey",
          "arg2Value": "formData.invoiceDetails",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyInvoiceDetails",
        "executeIf": "fn(LOGICAL,fn(LENGTH,{{fetchedData.invoiceDetails.data.cc}}),<,1)"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getCustomerDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/customers/{{fetchedData.invoiceDetails.data.customer}}",
          "arg2Key": "storeInVar",
          "arg2Value": "formData.customerDetails"
        },
        "name": "getCustomerDetails",
        "executeIf": "fn(NOT,{{formData.customerDetails}})"
      },
      {
        "executionOrder": 4,
        "name": "copyCCBody",
        "pageFunction": {
          "name": "copyCCBody",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getCCBody",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.ccBody"
        },  
        "executeIf": "fn(LOGICAL,fn(NOT,fn(NOT,{{fetchedData.invoiceDetails.data.qr}})),&&,fn(LOGICAL,fn(LENGTH,{{fetchedData.invoiceDetails.data.cc}}),<,1))"
      },
      {
        "executionOrder": 5,
        "pageFunction": {
          "name": "createInvoiceCC",
          "type": "fnSubmit",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/invoice/cc",
          "arg2Key": "postData",
          "arg2Value": "fetchedData.ccBody"
        },
        "name": "createInvoiceCC",
        "executeIf": "fn(LOGICAL,fn(NOT,fn(NOT,{{fetchedData.invoiceDetails.data.qr}})),&&,fn(LOGICAL,fn(LENGTH,{{fetchedData.invoiceDetails.data.cc}}),<,1))"
      },
      {
        "executionOrder": 4,
        "pageFunction": {
          "name": "copyVatPercentage",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getVatPercentage",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyVatPercentage"
      },
      {
        "executionOrder": 5,
        "pageFunction": {
          "name": "copyFormattedOrders",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getFormattedOrders",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyFormattedOrders"
      }
    ],
    "functions": [
      {
        "name": "getCCBody",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "modelId": "{{formData.invoiceDetails.data._id}}",
          "data": "{{formData}}"
        },
        "useFormula": true
      },
      {
        "name": "getVatPercentage",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "vatPercent": "fn(CONDITIONAL,{{formData.customerDetails.data.exportCustomer}},0,{{fetchedData.companyDetails.data.0.data.vatPercentage}})"
        },
        "useFormula": true
      },
      {
        "name": "getFormattedOrders",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "formattedOrders": "fn(HELPER_FN,formatOrderForInvoice,{{formData.invoiceDetails.data}},{{fetchedData.vatPercent}})"
        },
        "useFormula": true
      },
      {
        "name": "getInvoiceVersion",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "invoiceVersion": "fn(HELPER_FN,invoiceVersion,{{fetchedData.invoiceDetails.data}})"
        },
        "useFormula": true
      }
    ]
  },
  "forRole": "ACCOUNTING_MANAGER,ACCOUNTING_EXECUTIVE,SALES_ACCOUNT_EXECUTIVE,SALES_MANAGER,CUSTOMER_SERVICE_MANAGER,CUSTOMER_SERVICE_OUTBOUND_WAREHOUSE,GENERAL_MANAGER",
  "visible": false
}